import chroma from "chroma-js";
import { KnownArgumentNamesRule } from "graphql";
import { mapColorScaleDomain, scales } from "../../../../../colorscaleUtils";
import { DWPropertyScaleDesc, DWQueryConfig } from "../../../deckgl/DWEntityLayer";
import { dev } from "../../../utils/misc";
import { render } from "react-dom";

export const dwConfigs: DWQueryConfig[] = [
// Cultivar
{
    title: 'Cultivar',
    visible: false,
    definitionName: ['plant'],
    type: 'point',
    properties: [{
        title: 'Row',
        name: 'Row',
        property: 'Row',
        statistic: 'value',
        summerize: 'avg',
        geojson: false,
    },{
        title: 'Plant',
        name: 'Plant',
        property: 'Plant',
        statistic: 'value',
        summerize: 'avg',
        geojson: false,
    },{
        title: 'Cultivar',
        name: 'cultivar',
        property: 'Cultivar',
        statistic: 'name',
        summerize: 'avg',
        geojson: false,
    },{
        title: 'Status',
        name: 'status',
        property: 'status',
        statistic: 'name',
        summerize: 'avg',
        geojson: false,

    }
    /*{
        title: 'Canopy Volume',
        name: 'CanopyVolume',
        property: 'CanopyVolume',
        statistic: 'value',
        summerize: 'avg',
    }*/],

    layerType: 'geojson',
    colorRamp: 'Portland',
    layerOptions: {
        pointRadiusScale: 2.5,
        pointRadiusMinPixels: 2,
        filled: true,
        lineWidthScale: 0,
        pickable: true,
    },
    transform: async (scalers: DWPropertyScaleDesc[], colorRamp: string, data:any, fullData:any, dwEntityProps:any=null, dataRowCol:any=null, entity:string='plant', dwFilters:any, caller?:any) => {
        //console.log("111822 dwFilters['Vigor Mean']", dwFilters["Vigor Mean"]);
        console.log("D022324 caller", caller);
        console.log("D022324 dwFilters", dwFilters);
        console.log("D022324 data", data);
        console.log("D022324 fullData", fullData);
        console.log("D022324 cultivar dwEntityProps", dwEntityProps);
        console.log("D022324 transform cultivar dwEntityProps", dwEntityProps);
        if (!fullData || !fullData.features || ((Object.keys(dwEntityProps.statusData ? dwEntityProps.statusData : []).length === 0) && (Object.keys(dwEntityProps.cultivarData).length === 0))){       
            return [
                {name:null,data:null,override:null},
                {name:null,data:null,override:null},
                {},
                {"colorRampMaxMin":null},
                {"histogramData":null}
            ]
        } 
        let uniqueValues = null;
        let selectedBin = null;
        if (dwFilters?.Cultivar){   
            uniqueValues = dwFilters.Cultivar.config.data.filter(function(value:string, index:number, array:any ) {
                return array.indexOf(value) === index;
            })
            console.log("D112123 uniqueValues", uniqueValues);
            selectedBin = uniqueValues[(dwFilters.Cultivar.selectionRange[0] + dwFilters.Cultivar.selectionRange[1]) / 2];
            console.log("D112123 selectedBin", selectedBin);
        }
        console.log("B022124 fullData", fullData);
        console.log("B022124 dwEntityProps", dwEntityProps );
        let newFeatures = []
        let includeHistogramTable = true;
        if ((Object.keys(dwEntityProps.statusData ? dwEntityProps.statusData : [] ).length === 0 && dwEntityProps.statusData?.constructor === Object)){
            includeHistogramTable = false;
        }
        let colorDomains = {}
        for (let f of fullData.features){
            //if (f.properties.BloomIndex_value < 0.2){
            //if (!f.properties.BloomIndex_value){
            //    console.log("D022823 f < 0", f);
            //}
            //console.log("033123 dwEntityProps[f.properties[`${entity ? entity : 'plant'}_id`]]", dwEntityProps[f.properties[`${entity ? entity : 'plant'}_id`]])
            f.properties = {
                ...f.properties, 
                //"Cultivar_name": f.properties.cultivar_name ? f.properties.cultivar_name : (dwEntityProps.cultivarData[f.properties[`${entity ? entity : 'plant'}_id`]] ? dwEntityProps.cultivarData[f.properties[`${entity ? entity : 'plant'}_id`]]["Cultivar_name"] : "Black"),
                "Cultivar_name": (dwEntityProps.cultivarData[f.properties[`${entity ? entity : 'plant'}_id`]] ? dwEntityProps.cultivarData[f.properties[`${entity ? entity : 'plant'}_id`]]["Cultivar_name"] : "Black"),
                "status_name": dwEntityProps.statusData 
                    ? dwEntityProps.statusData[f.properties[`${entity ? entity : 'plant'}_id`]] ? dwEntityProps.statusData[f.properties[`${entity ? entity : 'plant'}_id`]]["status_name"] : "unknown"
                    : "",
                Row_value: dataRowCol ? dataRowCol[f.properties[`${entity ? entity : 'plant'}_id`]]?.row_value : null,
                Plant_value: dataRowCol ? dataRowCol[f.properties[`${entity ? entity : 'plant'}_id`]]?.Plant_value : null,
            }
            colorDomains[f.properties.Cultivar_name] = 'rgb(0, 0, 0)';
            if (dwFilters["Cultivar"] || dwFilters["Canopy Volume"]){
                let pushIt = true;
                if (dwFilters["Cultivar"]){
                    if (f.properties["Cultivar_name"] == selectedBin){
                    //if ((f.properties.treatmentcolor_value >= dwFilters["cultivar"].selectionRange[0]) && (f.properties.treatmentcolor_value <= dwFilters["cultivar"].selectionRange[1])){
                        // do nothing for now
                    }else{
                        pushIt = false;
                    }
                }
                /*if (dwFilters["Canopy Volume"]){
                    if ((f.properties.CanopyVolume_value >= dwFilters["Canopy Volume"].selectionRange[0]) && (f.properties.CanopyVolume_value <= dwFilters["Canopy Volume"].selectionRange[1])){
                        // do nothing for now
                    }else{
                        pushIt = false;
                    }
                }*/
                if(pushIt){
                    newFeatures.push(f);
                }
            }else{
                newFeatures.push(f);
            }
        }
        const categoryColors = {
            'Nonpareil': {"arr": [242, 210, 57], "rgb": 'rgb(242, 210, 57)'},
            'Supareil': {"arr": [109, 169, 130], "rgb": 'rgb(109, 169, 130)'},
            'Monterey': {"arr": [143, 159, 141], "rgb": 'rgb(143, 159, 141)'},
            'Wood Colony': {"arr": [63, 86, 37], "rgb": 'rgb(63, 86, 37)'},
            'Black': {"arr": [0, 0, 0], "rgb": 'rgb(0, 0, 0)'},
            'Alternates': { // Alternate colors will be assigned starting from position [0] when cultivar does not match the above names.
                "arr": [[140,81,10],[216,179,101],[246,232,195],[199,234,229],[90,180,172],[1,102,94]],
                "rgb": ['rgb(140,81,10)','rgb(216,179,101)','rgb(246,232,195)','rgb(199,234,229)','rgb(90,180,172)','rgb(1,102,94)']
            }
        }
        let altNumber = 0;
        Object.keys(colorDomains).forEach(key => {
            console.log("B112123", key + ": ", colorDomains[key]);
            console.log("B112123", categoryColors[key]);
            if (categoryColors[key]){
                colorDomains[key] = categoryColors[key].arr
            }else{
                colorDomains[key] = categoryColors["Alternates"].arr[altNumber];
                categoryColors[key] = {"arr":categoryColors["Alternates"].arr[altNumber],"rgb":categoryColors["Alternates"].rgb[altNumber]};
                altNumber++;
            }           
        });
        console.log("B112123", colorDomains);
        data.features = newFeatures;
        console.log("033123 newFeatures", newFeatures);
        console.log("033123 data", data);
        //let bloom = data.features.map((f: any) => categoryToValue[f.properties["cultivar_name"]] ? categoryToValue[f.properties["cultivar_name"]] : 5);
        let cultivar = data.features.map((f: any) => f.properties["Cultivar_name"]);
        let status_data = data.features.map((f: any) => [f.properties["Cultivar_name"], f.properties["status_name"]]);
        console.log("040223 cultivar", cultivar);
        const size = data.features.map((f: any) => f.properties.CanopyVolume_value);
        console.log("A022823 size", size);
        const cultivar_stats = dev(cultivar.filter((n:number) => n > 0));
        const size_stats = dev(size.filter((n:number) => n > 0));
        console.log("A022823 cultivar_stats", cultivar_stats);
        console.log("A022823 size_stats", size_stats);
        // determine if there are any range overrides
        const cultivarMeanScale = scalers.find((s:DWPropertyScaleDesc) => s.name === 'Cultivar_name');
        const cultivarCountScale = scalers.find((s:DWPropertyScaleDesc) => s.name === 'CanopyVolume_value');
        const cultivarRange = [0,0];//[Math.min(...bloom), Math.max(...bloom)] // Uncomment this to apply +-3 standard deviations: bloomMeanScale ? [bloomMeanScale.min, bloomMeanScale.max] : [bloom_stats[0]-(3*bloom_stats[1]), bloom_stats[0]+(3*bloom_stats[1])];
        // Use true range for normalizing radius (removed for now):
        // const sizeRange = vviCountScale ? [vviCountScale.min, vviCountScale.max] : [Math.min(...size.filter((n:number) => n > 0)), Math.max(...size.filter((n:number) => n > 0))];
        // Use +-3 standard deviations to find range for normalizing radius:
        const sizeRange = cultivarCountScale ? [cultivarCountScale.min, cultivarCountScale.max] : [size_stats[0]-(3*size_stats[1]), size_stats[0]+(3*size_stats[1])];
        
        // coloramp configuration
        const scaleDomain = mapColorScaleDomain(scales[colorRamp], cultivarRange[0], cultivarRange[1], true);
        const rampValues = scaleDomain.map((v:any) => v[0]);
        const rampColors = scaleDomain.map((v:any) => v[1]);
        var colorScale =  chroma.scale(rampColors).domain(rampValues);
        
        for (let f of data.features){
            //console.log("033123 f",f)
            f.properties = {
                ...f.properties, 
                size_scale: (
                    ((f.properties.CanopyVolume_value ? f.properties.CanopyVolume_value : 0 > sizeRange[1] 
                        ? sizeRange[1] 
                        : f.properties.CanopyVolume_value ? f.properties.CanopyVolume_value : 0 < sizeRange[0] 
                            ? sizeRange[0] 
                            : f.properties.CanopyVolume_value ? f.properties.CanopyVolume_value : 0
                    ) - sizeRange[0])/(sizeRange[1] - sizeRange[0])),
                point_color: colorDomains[f.properties["Cultivar_name"]],//colorScale(f.properties.treatmentcolor_value ? f.properties.treatmentcolor_value : 0).rgb(),
                Row_value: dataRowCol ? dataRowCol[f.properties[`${entity ? entity : 'plant'}_id`]]?.row_value : null,
                Plant_value: dataRowCol ? dataRowCol[f.properties[`${entity ? entity : 'plant'}_id`]]?.Plant_value: null,
                type: 'plant',
                }
        }
        let returnAble = [{
            name: 'cultivar_mean',
            data: [0,0],
            override: cultivarRange
        }, {
            name: 'size',
            data: [0,0],
            override: sizeRange
        },
        {},
        {"colorRampMaxMin":cultivarRange},
        {"histogramData":{
                cultivar_mean:{
                    name: "bloom",
                    title:"Cultivar", 
                    data:[...cultivar],
                    meta: {
                        max: 0,
                        min: 0
                    },
                    entity: entity ? entity : 'plant',
                    categoryColors: categoryColors,
                    status:{
                        data: includeHistogramTable ? [...status_data] : null
                    }
                },
                /*size: {
                    title: "Canopy Volume",
                    data:[...size],
                    entity: entity ? entity : 'plant',
                }*/
            }
        },
        {title:"Cultivar"}
        ];
        //returnAble.histogramData.vvi_mean.data = {...vvi}
        console.log("D022823 returnAble", returnAble);
        return returnAble;
    },
    accessors: {
        getPointRadius: (d:any) => 1,//d.properties.size_scale,
        getFillColor: (d:any) => {
            //console.log("B112123 d", d);
            return d.properties.point_color;
        },
        getTransformedName: (color:any) => {
            let returnable = color;
            if (color === "Black"){ returnable = "N/A"};
            return returnable;
        }
    }
},
// Treatment (color)
{
    title: 'Treatment (color)',
    visible: false,
    definitionName: ['plant'],
    type: 'point',
    properties: [{
        title: 'Row',
        name: 'Row',
        property: 'Row',
        statistic: 'value',
        summerize: 'avg',
        geojson: false,
    },{
        title: 'Plant',
        name: 'Plant',
        property: 'Plant',
        statistic: 'value',
        summerize: 'avg',
        geojson: false,
    },{
        title: 'Treatment Color',
        name: 'treatment color',
        property: 'treatment color',
        statistic: 'name',
        summerize: 'avg',
        geojson: false,
    },
    /*{
        title: 'Canopy Volume',
        name: 'CanopyVolume',
        property: 'CanopyVolume',
        statistic: 'value',
        summerize: 'avg',
    }*/],

    layerType: 'geojson',
    colorRamp: 'Portland',
    layerOptions: {
        pointRadiusScale: 2.5,
        pointRadiusMinPixels: 2,
        filled: true,
        lineWidthScale: 0,
        pickable: true,
    },
    transform: async (scalers: DWPropertyScaleDesc[], colorRamp: string, data:any, fullData:any, dwEntityProps:any=null, dataRowCol:any=null, entity:string='plant', dwFilters:any) => {
        //console.log("111822 dwFilters['Vigor Mean']", dwFilters["Vigor Mean"]);
        console.log("033123 dwFilters", dwFilters);
        console.log("033123 data", data);
        console.log("033123 fullData", fullData);
        console.log("033123 dwEntityProps", dwEntityProps);
        console.log("062923 transform treatment dwEntityProps", dwEntityProps);
        if (!fullData || !fullData.features || Object.keys(dwEntityProps.treatmentData).length === 0 ){       
            return [
                {name:null,data:null,override:null},
                {name:null,data:null,override:null},
                {},
                {"colorRampMaxMin":null},
                {"histogramData":null}
            ]
        }
        let uniqueValues = null;
        let selectedBin = null;
        if (dwFilters["Treatment Color"]){   
            uniqueValues = dwFilters["Treatment Color"].config.data.filter(function(value:string, index:number, array:any ) {
                return array.indexOf(value) === index;
            })
            console.log("033123 Treatment Color uniqueValues ", uniqueValues);
            selectedBin = uniqueValues[(dwFilters["Treatment Color"].selectionRange[0] + dwFilters["Treatment Color"].selectionRange[1]) / 2];
            console.log("033123 Treatment Color selectedBin ", selectedBin);
        }
        let newFeatures = []
        for (let f of fullData.features){
            //if (f.properties.BloomIndex_value < 0.2){
            //if (!f.properties.BloomIndex_value){
            //    console.log("D022823 f < 0", f);
            //}
            //console.log("033123 dwEntityProps[f.properties[`${entity ? entity : 'plant'}_id`]]", dwEntityProps[f.properties[`${entity ? entity : 'plant'}_id`]])
            f.properties = {
                ...f.properties, 
                "treatment color_name": dwEntityProps.treatmentData[f.properties[`${entity ? entity : 'plant'}_id`]] ? dwEntityProps.treatmentData[f.properties[`${entity ? entity : 'plant'}_id`]]["treatment color_name"] : "Black",
                Row_value: dataRowCol[f.properties[`${entity ? entity : 'plant'}_id`]]?.row_value,
                Plant_value: dataRowCol[f.properties[`${entity ? entity : 'plant'}_id`]]?.Plant_value
            }
            if (dwFilters["Treatment Color"] || dwFilters["Canopy Volume"]){
                let pushIt = true;
                if (dwFilters["Treatment Color"]){
                    if (f.properties["treatment color_name"] == selectedBin){
                    //if ((f.properties.treatmentcolor_value >= dwFilters["treatment color"].selectionRange[0]) && (f.properties.treatmentcolor_value <= dwFilters["treatment color"].selectionRange[1])){
                        // do nothing for now
                    }else{
                        pushIt = false;
                    }
                }
                /*if (dwFilters["Canopy Volume"]){
                    if ((f.properties.CanopyVolume_value >= dwFilters["Canopy Volume"].selectionRange[0]) && (f.properties.CanopyVolume_value <= dwFilters["Canopy Volume"].selectionRange[1])){
                        // do nothing for now
                    }else{
                        pushIt = false;
                    }
                }*/
                if(pushIt){
                    newFeatures.push(f);
                }
            }else{
                newFeatures.push(f);
            }
        }
       data.features = newFeatures;
       console.log("A022823 data", data);
       const categoryToValue = {"Yellow": 1, "Green": 2, "Blue": 3, "White": 4};
       //let bloom = data.features.map((f: any) => categoryToValue[f.properties["treatment color_name"]] ? categoryToValue[f.properties["treatment color_name"]] : 5);
       /*let bloom = data.features.map((f: any) => f.properties["treatment color_name"]);
       console.log("040223 bloom", bloom);
       const size = data.features.map((f: any) => f.properties.CanopyVolume_value);
       console.log("A022823 size", size);*/
       let size_max:Number = data.features[0].properties.CanopyVolume_value;
       let size_min:Number = data.features[0].properties.CanopyVolume_value;
        const bloom:number[] = [];
        const size:number[] = [];
        data.features.forEach((f: any) => {
            const treatmentValue = f.properties["treatment color_name"];
            const sizeValue = f.properties.CanopyVolume_value;
            if (sizeValue < size_min) {
                size_min = sizeValue;
            }
            if (sizeValue > size_max) {
                size_max = sizeValue;
            }
            bloom.push(treatmentValue);
            size.push(sizeValue);
        });
       const bloom_stats = dev(bloom.filter((n:number) => n > 0));
       const size_stats = dev(size.filter((n:number) => n > 0));
       console.log("A022823 bloom_stats", bloom_stats);
       console.log("A022823 size_stats", size_stats);
       // determine if there are any range overrides
       const bloomMeanScale = scalers.find((s:DWPropertyScaleDesc) => s.name === 'treatment color_name');
       const bloomCountScale = scalers.find((s:DWPropertyScaleDesc) => s.name === 'CanopyVolume_value');
       const bloomRange = [0,0];//[Math.min(...bloom), Math.max(...bloom)] // Uncomment this to apply +-3 standard deviations: bloomMeanScale ? [bloomMeanScale.min, bloomMeanScale.max] : [bloom_stats[0]-(3*bloom_stats[1]), bloom_stats[0]+(3*bloom_stats[1])];
       // Use true range for normalizing radius (removed for now):
       // const sizeRange = vviCountScale ? [vviCountScale.min, vviCountScale.max] : [Math.min(...size.filter((n:number) => n > 0)), Math.max(...size.filter((n:number) => n > 0))];
       // Use +-3 standard deviations to find range for normalizing radius:
       const sizeRange = bloomCountScale ? [bloomCountScale.min, bloomCountScale.max] : [size_stats[0]-(3*size_stats[1]), size_stats[0]+(3*size_stats[1])];
       
       // coloramp configuration
       const scaleDomain = mapColorScaleDomain(scales[colorRamp], bloomRange[0], bloomRange[1], true);
       const rampValues = scaleDomain.map((v:any) => v[0]);
       const rampColors = scaleDomain.map((v:any) => v[1]);
       var colorScale =  chroma.scale(rampColors).domain(rampValues);
    
       for (let f of data.features){
        //console.log("033123 f",f)
           f.properties = {
               ...f.properties, 
               size_scale: (
                ((f.properties.CanopyVolume_value ? f.properties.CanopyVolume_value : 0 > sizeRange[1] 
                    ? sizeRange[1] 
                    : f.properties.CanopyVolume_value ? f.properties.CanopyVolume_value : 0 < sizeRange[0] 
                        ? sizeRange[0] 
                        : f.properties.CanopyVolume_value ? f.properties.CanopyVolume_value : 0
                ) - sizeRange[0])/(sizeRange[1] - sizeRange[0])),
               bloom_color: f.properties["treatment color_name"],//colorScale(f.properties.treatmentcolor_value ? f.properties.treatmentcolor_value : 0).rgb(),
               type: 'plant',
            }
       }
       let returnAble = [{
            name: 'bloom_mean',
            data: [0,0],
            override: bloomRange
        }, {
            name: 'size',
            data: [size_min, size_max],
            override: sizeRange
        },
        {},
        {"colorRampMaxMin":bloomRange},
        {"histogramData":{
                bloom_mean:{
                    name: "bloom",
                    title:"Treatment Color", 
                    data:[...bloom],
                    meta: {
                        max: 0,
                        min: 0
                    },
                    entity: entity ? entity : 'plant',
                    categoryColors: {
                        'Blue': 'rgb(11,103,164)',
                        'White': 'rgb(255, 255, 255)',
                        'Green': 'rgb(109, 169, 130)',
                        'Yellow': 'rgb(242, 210, 57)',
                        'Black': 'rgb(0,0,0)',
                        'Alternates': ['rgb(140,81,10)','rgb(216,179,101)','rgb(246,232,195)','rgb(199,234,229)','rgb(90,180,172)','rgb(1,102,94)']
                      },
                },
                /*size: {
                    title: "Canopy Volume",
                    data:[...size],
                    entity: entity ? entity : 'plant',
                }*/
            }
        },
        {title:"Treatment (color)"}
        ];
        //returnAble.histogramData.vvi_mean.data = {...vvi}
        console.log("D022823 returnAble", returnAble);
        return returnAble;
    },
    accessors: {
        getPointRadius: (d:any) => 1,//d.properties.size_scale,
        getFillColor: (d:any) => {
            //console.log("033123 d", d);
            let returnable = [0,0,0];
            if(d.properties.bloom_color === "Yellow"){
                returnable = [242, 210, 57];
            }
            if(d.properties.bloom_color === "Green"){
                returnable = [109, 169, 130];
            }    
            if(d.properties.bloom_color === "White"){
                returnable = [255, 255, 255];
            }    
            if(d.properties.bloom_color === "Blue"){
                returnable = [11, 103, 164];
            }    
            if(d.properties.bloom_color === "Black"){
                returnable = [0, 0, 0];
            }    
            return returnable;
        },
        getTransformedName: (color:any) => {
            let returnable = color;
            if (color === "Yellow"){ returnable = "Baseline"};
            if (color === "Green"){ returnable = "Modified"};
            if (color === "Blue"){ returnable = "Improved"};
            if (color === "White"){ returnable = "MyAlmonds"};
            if (color === "Black"){ returnable = "NoTreatment"};
            return returnable;
        }
    }
},
// Bloom Index (color, radius)
{
    title: 'Bloom Index (color, radius)',
    visible: false,
    definitionName: ['plant'],
    type: 'point',
    properties: [{
        title: 'Row',
        name: 'Row',
        property: 'Row',
        statistic: 'value',
        summerize: 'avg',
        geojson: false,
    },{
        title: 'Plant',
        name: 'Plant',
        property: 'Plant',
        statistic: 'value',
        summerize: 'avg',
        geojson: false,
    },{
        title: 'Bloom Index',
        name: 'BloomIndex',
        property: 'Bloom Index',
        statistic: 'value',
        summerize: 'avg',
        geojson: false,
    },{
        title: 'Cultivar',
        name: 'cultivar',
        property: 'Cultivar',
        statistic: 'name',
        summerize: 'avg',
        geojson: false,
    },
    /*{
        title: 'Canopy Volume',
        name: 'CanopyVolume',
        property: 'CanopyVolume',
        statistic: 'value',
        summerize: 'avg',
    }*/],

    layerType: 'geojson',
    colorRamp: 'Portland',
    layerOptions: {
        pointRadiusScale: 2.5,
        pointRadiusMinPixels: 2,
        pointRadiusMaxPixels: 9,
        filled: true,
        lineWidthScale: 0,
        pickable: true,
    },
    transform: async (scalers: DWPropertyScaleDesc[], colorRamp: string, data:any, fullData:any, dwEntityProps:any=null, dataRowCol:any=null, entity:string='plant', dwFilters:any) => {
        //console.log("111822 dwFilters['Vigor Mean']", dwFilters["Vigor Mean"]);
        console.log("E022823 dwFilters", dwFilters);
        console.log("A021924 data", data);
        console.log("A021924 fullData", fullData);
        console.log("A021924 transform bloom index dwEntityProps", dwEntityProps);

        if (!fullData || !fullData.features || Object.keys(dwEntityProps.bloomData).length === 0 ){       
            return [
                {name:null,data:null,override:null},
                {name:null,data:null,override:null},
                {},
                {"colorRampMaxMin":null},
                {"histogramData":null}
            ]
        }
        let uniqueValues = null;
        let selectedBin = null;
        if (dwFilters?.Cultivar){   
            uniqueValues = dwFilters.Cultivar.config.data.filter(function(value:string, index:number, array:any ) {
                return array.indexOf(value) === index;
            })
            console.log("D112123 uniqueValues", uniqueValues);
            selectedBin = uniqueValues[(dwFilters.Cultivar.selectionRange[0] + dwFilters.Cultivar.selectionRange[1]) / 2];
            console.log("D112123 selectedBin", selectedBin);
        }
        let newFeatures = []
        let includeHistogramTable = true;
        if ((Object.keys(dwEntityProps.statusData).length === 0 && dwEntityProps.statusData.constructor === Object)){
            includeHistogramTable = false;
        }
        let colorDomains = {}
        console.log("022724 dwEntityProps", dwEntityProps);
        for (let f of fullData.features){
            //if (f.properties.BloomIndex_value < 0.2){
            //if (!f.properties.BloomIndex_value){
            //    console.log("D022823 f < 0", f);
            //}
            //console.log("021924 f", f);
            //console.log("021924 dwEntityProps.cultivarData[f.properties[`${entity ? entity : 'plant'}_id`]]", dwEntityProps.cultivarData[f.properties[`${entity ? entity : 'plant'}_id`]]);
            const featuresBloomValue = dwEntityProps.bloomData[f.properties[`${entity ? entity : 'plant'}_id`]] ? dwEntityProps.bloomData[f.properties[`${entity ? entity : 'plant'}_id`]]["Bloom Index_max"] : null;
            //console.log("022724 featuresBloomValue", featuresBloomValue);
            //console.log("022724 dwEntityProps.bloomData[f.properties[`${entity ? entity : 'plant'}_id`]]", dwEntityProps.bloomData[f.properties[`${entity ? entity : 'plant'}_id`]]);
            //console.log("022724 f.properties[`${entity ? entity : 'plant'}_id`]", f.properties[`${entity ? entity : 'plant'}_id`]);

            f.properties = {
                ...f.properties, 
                "Cultivar_name": dwEntityProps.cultivarData[f.properties[`${entity ? entity : 'plant'}_id`]] ? dwEntityProps.cultivarData[f.properties[`${entity ? entity : 'plant'}_id`]]["Cultivar_name"] : "Black",
                //"status_name": dwEntityProps.statusData 
                //    ? dwEntityProps.statusData[f.properties[`${entity ? entity : 'plant'}_id`]] ? dwEntityProps.statusData[f.properties[`${entity ? entity : 'plant'}_id`]]["status_name"] : "unknown"
                //    : "",
                // (on geojson) CanopyVolume_value: dwEntityProps.bloomData[f.properties[`${entity ? entity : 'plant'}_id`]]?.CanopyVolume_max,
                "Row_value": dwEntityProps.rowColData[f.properties[`${entity ? entity : 'plant'}_id`]] ? dwEntityProps.rowColData[f.properties[`${entity ? entity : 'plant'}_id`]]["row_value"] : null,
                "Plant_value": dwEntityProps.rowColData[f.properties[`${entity ? entity : 'plant'}_id`]] ? dwEntityProps.rowColData[f.properties[`${entity ? entity : 'plant'}_id`]]["Plant_value"] : null,
                "BloomIndex_value": featuresBloomValue,
            }
            
            colorDomains[f.properties.Cultivar_name] = 'rgb(0, 0, 0)';
            if (dwFilters["Bloom Index"] || dwFilters["Canopy Volume"] || dwFilters["Cultivar"]){
                let pushIt = true;
                if (dwFilters["Bloom Index"]){
                    if ((f.properties.BloomIndex_value >= dwFilters["Bloom Index"].selectionRange[0]) && (f.properties.BloomIndex_value <= dwFilters["Bloom Index"].selectionRange[1])){
                        // do nothing for now
                    }else{
                        pushIt = false;
                    }
                }
                /*if (dwFilters["Canopy Volume"]){
                    if ((f.properties.CanopyVolume_value >= dwFilters["Canopy Volume"].selectionRange[0]) && (f.properties.CanopyVolume_value <= dwFilters["Canopy Volume"].selectionRange[1])){
                        // do nothing for now
                    }else{
                        pushIt = false;
                    }
                }*/
                if (dwFilters["Cultivar"]){
                    if (f.properties["Cultivar_name"] == selectedBin){
                    //if ((f.properties.treatmentcolor_value >= dwFilters["cultivar"].selectionRange[0]) && (f.properties.treatmentcolor_value <= dwFilters["cultivar"].selectionRange[1])){
                        // do nothing for now
                    }else{
                        pushIt = false;
                    }
                }
                if(pushIt){
                    newFeatures.push(f);
                }
            }else{
                if (featuresBloomValue !== null){
                    newFeatures.push(f);
                }
            }
        }
        const categoryColors = {
            'Nonpareil': {"arr": [242, 210, 57], "rgb": 'rgb(242, 210, 57)'},
            'Supareil': {"arr": [109, 169, 130], "rgb": 'rgb(109, 169, 130)'},
            'Monterey': {"arr": [143, 159, 141], "rgb": 'rgb(143, 159, 141)'},
            'Wood Colony': {"arr": [63, 86, 37], "rgb": 'rgb(63, 86, 37)'},
            'Black': {"arr": [0, 0, 0], "rgb": 'rgb(0, 0, 0)'},
            'Alternates': { // Alternate colors will be assigned starting from position [0] when cultivar does not match the above names.
                "arr": [[140,81,10],[216,179,101],[246,232,195],[199,234,229],[90,180,172],[1,102,94]],
                "rgb": ['rgb(140,81,10)','rgb(216,179,101)','rgb(246,232,195)','rgb(199,234,229)','rgb(90,180,172)','rgb(1,102,94)']
            }
        }
        let altNumber = 0;
        Object.keys(colorDomains).forEach(key => {
            //console.log("B112123", key + ": ", colorDomains[key]);
            //console.log("B112123", categoryColors[key]);
            if (categoryColors[key]){
                colorDomains[key] = categoryColors[key].arr
            }else{
                colorDomains[key] = categoryColors["Alternates"].arr[altNumber];
                categoryColors[key] = {"arr":categoryColors["Alternates"].arr[altNumber],"rgb":categoryColors["Alternates"].rgb[altNumber]};
                altNumber++;
            }           
        });
        console.log("B112123", colorDomains);
        data.features = newFeatures;
        console.log("A021924 data", data);
        let cultivar_data = data.features.map((f: any) => f.properties["Cultivar_name"]);
        let cultivar_classed_data = {};
        data.features.forEach((f: any) => {
            //console.log("A021924 f.properties", f.properties);
            cultivar_classed_data[f.properties["Cultivar_name"] ? f.properties["Cultivar_name"] : "no class" ] 
                ? cultivar_classed_data[f.properties["Cultivar_name"] ? f.properties["Cultivar_name"] : "no class" ].push(f.properties.BloomIndex_value)
                : cultivar_classed_data[f.properties["Cultivar_name"] ? f.properties["Cultivar_name"] : "no class" ] = [f.properties.BloomIndex_value];
        });
        //let status_data = data.features.map((f: any) => [f.properties["Cultivar_name"], f.properties["status_name"]]);
        console.log("040223 cultivar_data", cultivar_data);
        //console.log("040223 status_data", status_data);
        /*let bloom = data.features.map((f: any) => f.properties.BloomIndex_value);
        console.log("A022823 bloom", bloom);
        const size = data.features.map((f: any) => f.properties.CanopyVolume_value);
        console.log("A022823 size", size);*/
        let bloom_min:number = data.features[0].properties.BloomIndex_value;
        let bloom_max:number = data.features[0].properties.BloomIndex_value;
        let size_min:number = data.features[0].properties.BloomIndex_value;
        let size_max:number = data.features[0].properties.BloomIndex_value;
        //let size_max:number = data.features[0].properties.CanopyVolume_value;
        //let size_min:number = data.features[0].properties.CanopyVolume_value;
        const bloom:number[] = [];
        const size:number[] = [];
        data.features.forEach((f: any) => {
            const bloomValue = f.properties.BloomIndex_value;
            const sizeValue = f.properties.BloomIndex_value; //f.properties.CanopyVolume_value;
            if (bloomValue < bloom_min) {
                bloom_min = bloomValue;
            }
            if (bloomValue > bloom_max) {
                bloom_max = bloomValue;
            }
            if (sizeValue < size_min) {
                size_min = sizeValue;
            }
            if (sizeValue > size_max) {
                size_max = sizeValue;
            }
            bloom.push(bloomValue);
            size.push(sizeValue);
        });
        const bloom_stats = dev(bloom.filter((n:number) => n > 0));
        const size_stats = dev(size.filter((n:number) => n > 0));
        console.log("A022823 bloom_stats", bloom_stats);
        console.log("A022823 size_stats", size_stats);
        // determine if there are any range overrides
        const bloomMeanScale = scalers.find((s:DWPropertyScaleDesc) => s.name === 'BloomIndex_value');
        //const bloomCountScale = scalers.find((s:DWPropertyScaleDesc) => s.name === 'CanopyVolume_value');
        const bloomRange = [bloom_min, bloom_max] // Uncomment this to apply +-3 standard deviations: bloomMeanScale ? [bloomMeanScale.min, bloomMeanScale.max] : [bloom_stats[0]-(3*bloom_stats[1]), bloom_stats[0]+(3*bloom_stats[1])];
        // Use true range for normalizing radius (removed for now):
        // const sizeRange = vviCountScale ? [vviCountScale.min, vviCountScale.max] : [Math.min(...size.filter((n:number) => n > 0)), Math.max(...size.filter((n:number) => n > 0))];
        // Use +-3 standard deviations to find range for normalizing radius:
        //const sizeRange = bloomCountScale ? [bloomCountScale.min, bloomCountScale.max] : [size_stats[0]-(3*size_stats[1]), size_stats[0]+(3*size_stats[1])];
        const sizeRangeBloom = bloomMeanScale ? [bloomMeanScale.min, bloomMeanScale.max] : [bloom_stats[0]-(3*bloom_stats[1]), bloom_stats[0]+(3*bloom_stats[1])];
        
        // coloramp configuration
        const scaleDomain = mapColorScaleDomain(scales[colorRamp], bloomRange[0], bloomRange[1], true);
        const rampValues = scaleDomain.map((v:any) => v[0]);
        const rampColors = scaleDomain.map((v:any) => v[1]);
        var colorScale =  chroma.scale(rampColors).domain(rampValues);
        
        for (let f of data.features){
            f.properties = {
                ...f.properties, 
                /*size_scale_canopy: ( // Not used at the moment
                    ((f.properties.CanopyVolume_value ? f.properties.CanopyVolume_value : 0 > sizeRange[1] 
                        ? sizeRange[1] 
                        : f.properties.CanopyVolume_value ? f.properties.CanopyVolume_value : 0 < sizeRange[0] 
                            ? sizeRange[0] 
                            : f.properties.CanopyVolume_value ? f.properties.CanopyVolume_value : 0
                    ) - sizeRange[0])/(sizeRange[1] - sizeRange[0])),*/
                size_scale: (
                    ((f.properties.BloomIndex_value ? f.properties.BloomIndex_value : 0 > sizeRangeBloom[1] 
                        ? sizeRangeBloom[1] 
                        : f.properties.BloomIndex_value ? f.properties.BloomIndex_value : 0 < sizeRangeBloom[0] 
                            ? sizeRangeBloom[0] 
                            : f.properties.BloomIndex_value ? f.properties.BloomIndex_value : 0
                    ) - sizeRangeBloom[0])/(sizeRangeBloom[1] - sizeRangeBloom[0])),
                bloom_color: colorScale(f.properties.BloomIndex_value ? f.properties.BloomIndex_value : 0).rgb(),
                type: 'plant',
                }
        }
        let renderHistogram = true;
        if ((bloom_max === null) && (bloom_min === null)){ renderHistogram = false };
        console.log("A022024 dwEntityProps.bloomData", dwEntityProps.bloomData);
        let returnAble = [
            {
                name: 'bloom_mean',
                data: [bloom_min,bloom_max],
                override: bloomRange
            }, {
                name: 'size',
                data: [bloom_min,bloom_max],
                override: sizeRangeBloom
            },
            {},
            {"colorRampMaxMin":bloomRange},
            {"histogramData": !renderHistogram 
            ? null 
            : {
                bloom_mean: {
                        name: "bloom",
                        title:"Bloom Index", 
                        data: [...bloom],
                        classData: {...cultivar_classed_data},
                        meta: {
                            max: bloom_max,
                            min: bloom_min
                        },
                        categoryColors: categoryColors,
                        entity: entity ? entity : 'plant',
                    },
                    /*cultivar:{
                        name: "cultivar",
                        title:"Cultivar", 
                        data:[...cultivar_data],
                        meta: {
                            max: 0,
                            min: 0
                        },
                        entity: entity ? entity : 'plant',
                        categoryColors: categoryColors,
                        //status:{
                        //    data: includeHistogramTable ? [...status_data] : null
                        //}
                    },*/
                    //size: {
                    //    title: "Canopy Volume",
                    //    data:[...size],
                    //    entity: entity ? entity : 'plant',
                    //}
                }
            },
            {title:"Bloom Index (color, radius)"}
        ];
        //returnAble.histogramData.vvi_mean.data = {...vvi}
        console.log("D022823 returnAble", returnAble);
        return returnAble;
    },
    accessors: {
        getPointRadius: (d:any) => d.properties.size_scale,
        getFillColor: (d:any) => d.properties.bloom_color
    }
},
// Vigor (color), Canopy Volume (radius)
{
    title: 'Vigor (color) Canopy Volume (radius)',
    visible: false,
    definitionName: ['plant'],
    type: 'point',
    properties: [
    {
        title: 'Vigor',
        name: 'vvi',
        property: 'vvi',
        statistic: 'mean',
        summerize: 'avg',
        geojson: false,
    },
    {
        title: 'Row',
        name: 'Row',
        property: 'Row',
        statistic: 'value',
        summerize: 'avg',
        geojson: false,
    },{
        title: 'Plant',
        name: 'Plant',
        property: 'Plant',
        statistic: 'value',
        summerize: 'avg',
        geojson: false,
    },
    {
        title: 'Canopy Volume',
        name: 'CanopyVolume',
        property: 'CanopyVolume',
        statistic: 'value',
        summerize: 'avg',
        geojson: false,
    }],

    layerType: 'geojson',
    colorRamp: 'Portland',
    layerOptions: {
        pointRadiusScale: 2.5,
        pointRadiusMinPixels: 2,
        filled: true,
        lineWidthScale: 0,
        pickable: true,
    },
    transform: async (scalers: DWPropertyScaleDesc[], colorRamp: string, data:any, fullData:any, dwEntityProps:any=null, dataRowCol:any=null, entity:string='plant', dwFilters:any) => {
        console.log("111822 dwFilters['Vigor Mean']", dwFilters["Vigor Mean"]);
        console.log("111822 dwFilters", dwFilters);
        console.log("C053024 data", data);
        console.log("C053024 fullData", fullData);
        console.log("062923 transform canopy volume, vvi dwEntityProps", dwEntityProps);
        if (!fullData || !fullData.features || (Object.keys(dwEntityProps.canopyData).length === 0 && Object.keys(dwEntityProps.vigorData).length === 0)){           
            return [
                {name:null,data:null,override:null},
                {name:null,data:null,override:null},
                {},
                {"colorRampMaxMin":null},
                {"histogramData":null}
            ]
        }
        let newFeatures = []
        console.log("111524 dataRowCol", dataRowCol);
        console.log("111524 fullData.features", fullData.features);
        for (let f of fullData.features){
            f.properties = {
                ...f.properties, 
                CanopyVolume_value: dwEntityProps.canopyData[f.properties[`${entity ? entity : 'plant'}_id`]]?.CanopyVolume_max,
                vvi_mean: dwEntityProps.vigorData[f.properties[`${entity ? entity : 'plant'}_id`]]?.vvi_mean,
                Row_value: dataRowCol ? dataRowCol[f.properties[`${entity ? entity : 'plant'}_id`]]?.row_value : null,
                Plant_value: dataRowCol ? dataRowCol[f.properties[`${entity ? entity : 'plant'}_id`]]?.Plant_value : null,
            }
            if (dwFilters["Vigor Mean"] || dwFilters["Canopy Volume"]){
                let pushIt = true;
                if (dwFilters["Vigor Mean"]){
                    if ((f.properties.vvi_mean >= dwFilters["Vigor Mean"].selectionRange[0]) && (f.properties.vvi_mean <= dwFilters["Vigor Mean"].selectionRange[1])){
                        // do nothing for now
                    }else{
                        pushIt = false;
                    }
                }
                if (dwFilters["Canopy Volume"]){
                    if ((f.properties.CanopyVolume_value >= dwFilters["Canopy Volume"].selectionRange[0]) && (f.properties.CanopyVolume_value <= dwFilters["Canopy Volume"].selectionRange[1])){
                        // do nothing for now
                    }else{
                        pushIt = false;
                    }
                }
                if(pushIt){
                    newFeatures.push(f);
                }
            }else{
                newFeatures.push(f);
            }
        }
       data.features = newFeatures;
       console.log("C053024 data", data);
       let vvi_min:Number = data.features[0].properties.vvi_mean;
       let vvi_max:Number = data.features[0].properties.vvi_mean;
       let size_max:Number = data.features[0].properties.CanopyVolume_value;
       let size_min:Number = data.features[0].properties.CanopyVolume_value;
        const vvi:number[] = [];
        const size:number[] = [];
        data.features.forEach((f: any) => {
            const vviValue = f.properties.vvi_mean;
            const sizeValue = f.properties.CanopyVolume_value;
            if (vviValue < vvi_min) {
                vvi_min = vviValue;
            }
            if (vviValue > vvi_max) {
                vvi_max = vviValue;
            }
            if (sizeValue < size_min) {
                size_min = sizeValue;
            }
            if (sizeValue > size_max) {
                size_max = sizeValue;
            }
            vvi.push(vviValue);
            size.push(sizeValue);
        });
       const vvi_stats = dev(vvi.filter((n:number) => n > 10));
       const size_stats = dev(size.filter((n:number) => n > 0));
       console.log("C053024 vvi_stats", vvi_stats);
       // determine if there are any range overrides
       const vviMeanScale = scalers.find((s:DWPropertyScaleDesc) => s.name === 'vvi_mean');
       const vviCountScale = scalers.find((s:DWPropertyScaleDesc) => s.name === 'CanopyVolume_value');
       const vviRange = vviMeanScale ? [vviMeanScale.min, vviMeanScale.max] : [vvi_stats[0]-(3*vvi_stats[1]), vvi_stats[0]+(3*vvi_stats[1])];
       // Use true range for normalizing radius (removed for now):
       // const sizeRange = vviCountScale ? [vviCountScale.min, vviCountScale.max] : [Math.min(...size.filter((n:number) => n > 0)), Math.max(...size.filter((n:number) => n > 0))];
       // Use +-3 standard deviations to find range for normalizing radius:
       const sizeRange = vviCountScale ? [vviCountScale.min, vviCountScale.max] : [size_stats[0]-(3*size_stats[1]), size_stats[0]+(3*size_stats[1])];
       console.log("C053024 sizeRange", sizeRange);
       // coloramp configuration
       const scaleDomain = mapColorScaleDomain(scales[colorRamp], vviRange[0], vviRange[1], true);
       const rampValues = scaleDomain.map((v:any) => v[0]);
       const rampColors = scaleDomain.map((v:any) => v[1]);
       var colorScale =  chroma.scale(rampColors).domain(rampValues);
    
       for (let f of data.features){
           f.properties = {
               ...f.properties, 
               size_scale: (
                ((f.properties.CanopyVolume_value
                    ? f.properties.CanopyVolume_value > sizeRange[1] 
                        ? sizeRange[1] 
                        : f.properties.CanopyVolume_value < sizeRange[0] 
                            ? sizeRange[0] 
                            : f.properties.CanopyVolume_value
                    : 0) - sizeRange[0])/(sizeRange[1] - sizeRange[0])),
               vvi_color: colorScale(f.properties.vvi_mean).rgb(),
               type: 'plant',
            }
       }
       let returnAble = [{
            name: 'vvi_mean',
            data: [vvi_min, vvi_max],
            override: vviRange
        }, {
            name: 'size',
            data: [size_min, size_max],
            override: sizeRange
        },
        {},
        {"colorRampMaxMin":vviRange},
        {"histogramData":{
                vvi_mean:{
                    name: "vvi",
                    title:"Vigor Mean", 
                    data:[...vvi],
                    meta: {
                        max: vvi_max,
                        min: vvi_min
                    },
                    entity: entity ? entity : 'plant',
                },
                size: {
                    title: "Canopy Volume",
                    data:[...size],
                    entity: entity ? entity : 'plant',
                }
            }
        },
        {title:"Vigor (color), Canopy Volume (radius)"}
        ];
        //returnAble.histogramData.vvi_mean.data = {...vvi}
        console.log("H111822 returnAble", returnAble);
        return returnAble;
    },
    accessors: {
        getPointRadius: (d:any) => d.properties.size_scale,
        getFillColor: (d:any) => d.properties.vvi_color
    }
},
// Pigment (color), Canopy Volume (radius)
{
    title: 'Pigment (color), Canopy Volume (radius)',
    definitionName: ['plant'],
    visible: false,
    type: 'point',
    properties: [{
        title: 'Pigment Mean',
        name: 'pgi',
        property: 'pgi',
        statistic: 'mean',
        summerize: 'avg',
        geojson: false,
        // scale: {
        //     min: 146,
        //     max:155
        // }
    },{
        title: 'Row',
        name: 'Row',
        property: 'Row',
        statistic: 'value',
        summerize: 'avg',
        geojson: false,
    },{
        title: 'Plant',
        name: 'Plant',
        property: 'Plant',
        statistic: 'value',
        summerize: 'avg',
        geojson: false,
    },{
        title: 'Canopy Volume',
        name: 'CanopyVolume',
        property: 'CanopyVolume',
        statistic: 'value',
        summerize: 'avg',
        geojson: false,
    }],

    layerType: 'geojson',
    colorRamp: 'Portland',
    layerOptions: {
        pointRadiusScale: 2.5,
        pointRadiusMinPixels: 2,
        filled: true,
        lineWidthScale: 0,
        pickable: true,
    },
    transform: async (scalers: DWPropertyScaleDesc[], colorRamp: string, data:any, fullData:any, dwEntityProps:any=null, dataRowCol:any=null, entity:string='plant', dwFilters:any) => {
        console.log("111822 dwFilters", dwFilters);
        console.log("062923 transform canopy volume, pgi dwEntityProps", dwEntityProps);
        console.log("111524 data", data);
        console.log("111524 fullData", fullData);
        console.log("111524 dwEntityProps.canopyData", dwEntityProps.canopyData);
        console.log("111524 dwEntityProps.pigmentDataa", dwEntityProps.pigmentData);
        if (!fullData || !fullData.features || (/*(Object.keys(dwEntityProps.canopyData).length === 0) &&*/ (Object.keys(dwEntityProps.pigmentData).length === 0) )){       
            return [
                {name:null,data:null,override:null},
                {name:null,data:null,override:null}, 
                {},
                {"colorRampMaxMin":null},
                {"histogramData":null}
            ]
        }
        let newFeatures = []
        console.log("111524 dwEntityProps.pigmentData", dwEntityProps.pigmentData);
        for (let f of fullData.features){
            f.properties = {
                ...f.properties, 
                pgi_mean: dwEntityProps.pigmentData[f.properties[`${entity ? entity : 'plant'}_id`]]?.pgi_mean,
                CanopyVolume_value: dwEntityProps.canopyData[f.properties[`${entity ? entity : 'plant'}_id`]]?.CanopyVolume_max,
                Row_value: dataRowCol ? dataRowCol[f.properties[`${entity ? entity : 'plant'}_id`]]?.row_value : null,
                Plant_value: dataRowCol ? dataRowCol[f.properties[`${entity ? entity : 'plant'}_id`]]?.Plant_value : null
            }
            if (dwFilters["Pigment Mean"] || dwFilters["Canopy Volume"]){
                let pushIt = true;
                if (dwFilters["Pigment Mean"]){
                    if ((f.properties.pgi_mean >= dwFilters["Pigment Mean"].selectionRange[0]) && (f.properties.pgi_mean <= dwFilters["Pigment Mean"].selectionRange[1])){
                        // do nothing for now
                    }else{
                        pushIt = false;
                    }
                }
                if (dwFilters["Canopy Volume"]){
                    if ((f.properties.CanopyVolume_value >= dwFilters["Canopy Volume"].selectionRange[0]) && (f.properties.CanopyVolume_value <= dwFilters["Canopy Volume"].selectionRange[1])){
                        // do nothing for now
                    }else{
                        pushIt = false;
                    }
                }
                if(pushIt){
                    newFeatures.push(f);
                }
            }else{
                newFeatures.push(f);
            }

        }
       data.features = newFeatures;
       console.log("H111822 data", data);
       /*
       const pgi = data.features.map((f: any) => f.properties.pgi_mean);
       const size = data.features.map((f: any) => f.properties.CanopyVolume_value);
       */
       let pgi_min:Number = data.features[0].properties.pgi_mean;
       let pgi_max:Number = data.features[0].properties.pgi_mean;
       let size_max:Number = data.features[0].properties.CanopyVolume_value;
       let size_min:Number = data.features[0].properties.CanopyVolume_value;
        const pgi:number[] = [];
        const size:number[] = [];
        data.features.forEach((f: any) => {
            const pgiValue = f.properties.pgi_mean;
            const sizeValue = f.properties.CanopyVolume_value;
            if (pgiValue < pgi_min) {
                pgi_min = pgiValue;
            }
            if (pgiValue > pgi_max) {
                pgi_max = pgiValue;
            }
            if (sizeValue < size_min) {
                size_min = sizeValue;
            }
            if (sizeValue > size_max) {
                size_max = sizeValue;
            }
            pgi.push(pgiValue);
            size.push(sizeValue);
        });
       const pgiMeanScale = scalers.find((s:DWPropertyScaleDesc) => s.name === 'pgi_mean');
       const pgiCountScale = scalers.find((s:DWPropertyScaleDesc) => s.name === 'CanopyVolume_value');

       const pgi_stats = dev(pgi.filter((n:number) => n > 10));
       const size_stats = dev(size.filter((n:number) => n > 0));
       const pgiRange = pgiMeanScale ? [pgiMeanScale.min, pgiMeanScale.max] : [pgi_stats[0]-(3*pgi_stats[1]), pgi_stats[0]+(3*pgi_stats[1])];
       
       //const sizeRangeX = pgiCountScale ? [pgiCountScale.min, pgiCountScale.max] : [Math.min(...size), Math.max(...size)]; // include 0 values if they exist
       // Use true range for normalizing radius (removed for now):
       // const sizeRange = pgiCountScale ? [pgiCountScale.min, pgiCountScale.max] : [Math.min(...size.filter((n:number) => n > 0)), Math.max(...size.filter((n:number) => n > 0))]; // exclude 0 values
       // Use +-3 standard deviations to find range for normalizing radius:
       const sizeRange = pgiCountScale ? [pgiCountScale.min, pgiCountScale.max] : [size_stats[0]-(3*size_stats[1]), size_stats[0]+(3*size_stats[1])];
       
       
       // coloramp configuration
       const scaleDomain = mapColorScaleDomain(scales[colorRamp], pgiRange[0], pgiRange[1], true);
       const rampValues = scaleDomain.map((v:any) => v[0]);
       const rampColors = scaleDomain.map((v:any) => v[1]);
       var colorScale =  chroma.scale(rampColors).domain(rampValues);
       //console.log("B060324 -------------------------------------------------------------");
       //console.log("B060324 sizeRange", sizeRange);
       for (let f of data.features){
            let testSize = (f.properties.CanopyVolume_value 
                ? (f.properties.CanopyVolume_value > sizeRange[1] 
                    ? sizeRange[1] 
                    : f.properties.CanopyVolume_value < sizeRange[0] 
                        ? sizeRange[0] 
                        : f.properties.CanopyVolume_value
                ) - sizeRange[0]
                : 0 )/(sizeRange[1] - sizeRange[0])
            //if (!f.properties.CanopyVolume_value){
            //    console.log("B060324 f.properties.CanopyVolume_value", f.properties.CanopyVolume_value);
            //    console.log("B060324 testSize", testSize);
            //}
            f.properties = {
               ...f.properties, 
               pgi_color: colorScale(f.properties.pgi_mean).rgb(),
               size_scale: testSize,
               type: 'plant',
            }
       }

        return [{
            name: 'pgi_mean',
            data: [pgi_min, pgi_max],
            override: pgiRange
        }, {
            name: 'size',
            data: [size_min, size_max],
            override: sizeRange
        },
        {},
        {"colorRampMaxMin":pgiRange},
        {"histogramData":{
            pgi_mean:{
                name: "pgi",
                title:"Pigment Mean", 
                data:[...pgi],
                entity: entity ? entity : 'plant',
            },
            size: {
                title: "Canopy Volume",
                data:[...size],
                entity: entity ? entity : 'plant',
            }
        }
    },
    {title:"Pigment (color), Canopy Volume (radius)"}
    ];
    },
    accessors: {
        getPointRadius: (d:any) => d.properties.size_scale,
        getFillColor: (d:any) => d.properties.pgi_color
    }
},
// Vigor (color), Plant Height (height)
{
    title: 'Vigor (color) Plant Height (height)',
    definitionName: ['plant'],
    visible: false,
    type: 'point',
    properties: [{
        title: 'Vigor',
        name: 'vvi',
        property: 'vvi',
        statistic: 'mean',
        summerize: 'avg', 
        geojson: false,
    },{
        title: 'Row',
        name: 'Row',
        property: 'Row',
        statistic: 'value',
        summerize: 'avg',
        geojson: false,
    },{
        title: 'Plant',
        name: 'Plant',
        property: 'Plant',
        statistic: 'value',
        summerize: 'avg',
        geojson: false,
    },{
        title: 'Plant Height',
        name: 'height',
        property: 'height',
        statistic: 'mean',
        summerize: 'avg', 
        geojson: false,
    },
    {
        title: 'Canopy Volume',
        name: 'CanopyVolume',
        property: 'CanopyVolume',
        statistic: 'value',
        summerize: 'avg',
        geojson: false,
    }],

    layerType: 'column',
    colorRamp: 'Portland',
    layerOptions: {
        diskResolution: 6,
        radius: 2, // Default units is meters
        coverage: 1, // The radius of the disk is calculated by coverage * radius
        extruded: true,
        elevationScale: 10,
        //stroked: false,
        filled: true,
        pickable: true,    
    },
    transform: async (scalers: DWPropertyScaleDesc[], colorRamp: string, data:any, fullData:any, dwEntityProps:any=null, dataRowCol:any=null, entity:string='plant', dwFilters:any ) => {
        console.log("111822 dwFilters", dwFilters);
        console.log("062923 transform plant height dwEntityProps", dwEntityProps);
       if (!data || !data.features || (Object.keys(dwEntityProps.heightData).length === 0 && Object.keys(dwEntityProps.vigorData).length === 0)){       
        return [
            {name:null,data:null,override:null},
            {name:null,data:null,override:null},
            {},
            {"colorRampMaxMin":null},
            {"histogramData":null}
        ]
       }
        let newFeatures = []
        for (let f of fullData.features){
            f.properties = {
                ...f.properties, 
                height_mean: dwEntityProps.heightData[f.properties[`${entity ? entity : 'plant'}_id`]]?.height_mean,
                CanopyVolume_value: dwEntityProps.canopyData[f.properties[`${entity ? entity : 'plant'}_id`]]?.CanopyVolume_max,
                Row_value: dataRowCol ? dataRowCol[f.properties[`${entity ? entity : 'plant'}_id`]]?.row_value : null,
                Plant_value: dataRowCol ? dataRowCol[f.properties[`${entity ? entity : 'plant'}_id`]]?.Plant_value : null
            }
            if (dwFilters["Vigor Mean"] || dwFilters["Plant Height"]){
                let pushIt = true;
                if (dwFilters["Vigor Mean"]){
                    if ((f.properties.vvi_mean >= dwFilters["Vigor Mean"].selectionRange[0]) && (f.properties.vvi_mean <= dwFilters["Vigor Mean"].selectionRange[1])){
                        // do nothing for now
                    }else{
                        pushIt = false;
                    }
                }
                if (dwFilters["Plant Height"]){
                    if ((f.properties.height_mean >= dwFilters["Plant Height"].selectionRange[0]) && (f.properties.height_mean <= dwFilters["Plant Height"].selectionRange[1])){
                        // do nothing for now
                    }else{
                        pushIt = false;
                    }
                }
                if(pushIt){
                    newFeatures.push(f);
                }
            }else{
                newFeatures.push(f);
            }
        }
       data.features = newFeatures;
       console.log("H111822 data", data);
       /*
       const height = data.features.map((f: any) => f.properties.height_mean);
       const vvi = data.features.map((f: any) => f.properties.vvi_mean);
       const size = data.features.map((f: any) => f.properties.vvi_count);
        */
       let vvi_min:Number = data.features[0].properties.vvi_mean;
       let vvi_max:Number = data.features[0].properties.vvi_mean;
       let size_max:Number = data.features[0].properties.CanopyVolume_value;
       let size_min:Number = data.features[0].properties.CanopyVolume_value;
       let height_max:Number = data.features[0].properties.height_mean;
       let height_min:Number = data.features[0].properties.height_mean;
        const vvi:number[] = [];
        const size:number[] = [];
        const height:number[] = [];
        data.features.forEach((f: any) => {
            const vviValue = f.properties.vvi_mean;
            const sizeValue = f.properties.CanopyVolume_value;
            const heightValue = f.properties.height_mean;
            if (vviValue < vvi_min) {
                vvi_min = vviValue;
            }
            if (vviValue > vvi_max) {
                vvi_max = vviValue;
            }
            if (sizeValue < size_min) {
                size_min = sizeValue;
            }
            if (sizeValue > size_max) {
                size_max = sizeValue;
            }
            if (heightValue < height_min) {
                height_min = heightValue;
            }
            if (heightValue > height_max) {
                height_max = heightValue;
            }
            vvi.push(vviValue);
            size.push(sizeValue);
            height.push(heightValue);
        });
       const heightMeanScale = scalers.find((s:DWPropertyScaleDesc) => s.name === 'height_mean');
       const vviMeanScale = scalers.find((s:DWPropertyScaleDesc) => s.name === 'vvi_mean');
       const vviCountScale = scalers.find((s:DWPropertyScaleDesc) => s.name === 'vvi_count');

       const vvi_stats = dev(vvi.filter((n:number) => n > 10));
       const height_stats = dev(height.filter((n:number) => n > 0));
       const size_stats = dev(size.filter((n:number) => n > 0));
        //const vviRange = vviMeanScale ? [vviMeanScale.min, vviMeanScale.max] : [Math.min(...vvi), Math.max(...vvi)];
       const vviRange = vviMeanScale ? [vviMeanScale.min, vviMeanScale.max] : [vvi_stats[0]-(3*vvi_stats[1]), vvi_stats[0]+(3*vvi_stats[1])];

       // Use true range for normalizing radius (removed for now):
       // const sizeRange = vviCountScale ? [vviCountScale.min, vviCountScale.max] : [Math.min(...size), Math.max(...size)];
       // Use +-3 standard deviations to find range for normalizing radius:
       const sizeRange = vviCountScale ? [vviCountScale.min, vviCountScale.max] : [size_stats[0]-(3*size_stats[1]), size_stats[0]+(3*size_stats[1])];
       
       // Use true range for normalizing extrusion height (removed for now):
       // const heightRange = heightMeanScale ? [heightMeanScale.min, heightMeanScale.max] : [Math.min(...height), Math.max(...height)];
       // Use +-3 standard deviations to find range for normalizing radius:
       const heightRange = heightMeanScale ? [heightMeanScale.min, heightMeanScale.max] : [height_stats[0]-(3*height_stats[1]), height_stats[0]+(3*height_stats[1])];
       
       const scaleDomain = mapColorScaleDomain(scales[colorRamp], vviRange[0], vviRange[1], true);
       const rampValues = scaleDomain.map((v:any) => v[0]);
       const rampColors = scaleDomain.map((v:any) => v[1]);
       var colorScale =  chroma.scale(rampColors).domain(rampValues);
       let histogramData = {};
       for (let f of data.features){
           f.properties = {
               ...f.properties, 
               height_scale: (
                ((f.properties.height_mean > heightRange[1] 
                    ? heightRange[1] 
                    : f.properties.height_mean < heightRange[0] 
                        ? heightRange[0]
                        : f.properties.height_mean
                ) - heightRange[0])/(heightRange[1] - heightRange[0])),
               size_scale: (
                ((f.properties.CanopyVolume_value 
                    ? f.properties.CanopyVolume_value > sizeRange[1] 
                        ? sizeRange[1] 
                        : f.properties.CanopyVolume_value < sizeRange[0] 
                            ? sizeRange[0] 
                            : f.properties.CanopyVolume_value
                    : 0) - sizeRange[0])/(sizeRange[1] - sizeRange[0])),
               vvi_color: colorScale(f.properties.vvi_mean).rgb(),
               type: 'plant',
            }
            //console.log(f.properties);
            //histogramData[""]
       }

        return [{
            name: 'height',
            data: [height_min, height_max],
            override: heightRange
        },
            {
            name: 'vvi_mean',
            data: [vvi_min, vvi_max],
            override: vviRange
        }, {
            name: 'size',
            data: [size_min, size_max],
            override: sizeRange
        },
        {"colorRampMaxMin":vviRange},
        {"histogramData":{
                vvi_mean:{
                    name: "vvi",
                    title:"Vigor Mean", 
                    data:[...vvi],
                    entity: entity ? entity : 'plant',
                },
                height: {
                    title: "Plant Height",
                    data:[...height],
                    maxMin:[height_min, height_max],
                    entity: entity ? entity : 'plant',
                }
            }
        },
        {title:"Vigor (color), Plant Height (height)"}
    ];
    },
    accessors: {
        getPosition: (d: any) => d.geometry.coordinates,
        //getFillColor: (d:any) => d.properties.vvi_color,
        getElevation: (d:any) => d.properties.height_scale
     }
}];


export const dwStackConfigs: DWQueryConfig[] = [{
    title: 'Soil Horizons',
    visible: false,
    definitionName: ['plant'],
    type: 'point',
    properties: [{
        title: 'Stacked Test',
        name: 'vvi',
        property: 'vvi',
        statistic: 'mean',
        summerize: 'avg',
    }],

    layerType: 'geojson',
    colorRamp: 'Portland',
    layerOptions: {
        // pointRadiusScale: 2.5,
        filled: true,
        lineWidthScale: 0,
        pickable: true,
    },
    accessors: {
    }
}];